import { find, has } from "ramda";

export const getOrgIdForProcessing = content => {
  const org = find(has("programOrganizationId"), content.sources);
  return content?.organizationId ?? org?.programOrganizationId;
};

export const getOwnersForProcessing = content => {
  const sources = content?.sources ?? [];
  return [
    content?.organizationId,
    ...sources.map(source => source?.programOrganizationId),
  ].filter(o => o);
};
